import { parseJwt } from '@hyphengroup/cms-components/modules/auth/shared';

export type { IdentityClaims } from '@hyphengroup/cms-components/modules/auth/shared';
export { parseIdentityToken } from '@hyphengroup/cms-components/modules/auth/shared';

/** Available claims from the access token */
export type AccessClaims = {
  readonly sub: string;
  readonly email_verified: boolean;
  readonly email: string;
  readonly exp: number;
  readonly tid: string;
};

export function parseAccessToken(token: string): AccessClaims {
  return parseJwt(token) as AccessClaims;
}
